import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import './Auth.css'
import Logo from '../Images/logoblack.svg';

// Firebase
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { app } from "../firebase.js";
import { resolveUserRole } from "../utils/authRoles";

function Login() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const auth = getAuth(app);
  const db = getFirestore(app);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      try {
        const { role } = await resolveUserRole(db, user.uid);
        if (role === "admin") navigate("/dashboard");
        if (role === "client") navigate("/my-orders");
      } catch (error) {
        console.error("Error checking role:", error);
      }
    });

    return () => unsub();
  }, [auth, db, navigate]);

  const handleLogin = async () => {
    if (!email || !password) {
      swal("Missing Fields", "Please fill in both email and password.", "warning");
      return;
    }

    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const { role } = await resolveUserRole(db, user.uid);

      if (role === "admin") {
        swal("Success", "Logged in successfully!", "success");
        navigate("/dashboard");
        return;
      }

      if (role === "client") {
        swal("Success", "Logged in successfully!", "success");
        navigate("/my-orders");
        return;
      }

      await signOut(auth);
      swal(
        "User Not Found",
        "Your account does not exist in the system. Please register first.",
        "error"
      );

    } catch (error) {
      console.error(error);
      swal("Login Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='authMain'>
      <div className='authLeft'></div>
      <div className='authRight'>


        <div>
          <Link to='/'><img src={Logo} alt="" className="authRightLogo" /></Link>
          {/* <h2 className="myPrimaryColor">Sign In</h2>  */}
          <p className="text-muted">Sign in to your Dropoff Mtaani account.</p>

        </div>

        <Form.Group className="mt-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <br />

        <Button
          variant="success"
          className="mt-3 btnLogin w-100"
          disabled={loading}
          onClick={handleLogin}
        >
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              Logging In...
            </>
          ) : (
            "Login to your Account"
          )}
        </Button>

        <div className="signuptextCont mt-3">
          <h6 className="text-muted">
            New customer? <Link to="/register">Create Account</Link>
          </h6>
        </div>
      </div>
    </div>
  );
}

export default Login;
